import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { RegExpPatterns } from 'src/app/share/enums/regex-pattern.enum';
import { RegisterService } from 'src/app/share/services/register/register.service';
import { AuthService } from '../auth/auth.service';
import { faPen, faCheckCircle } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    standalone: false
})
export class RegisterComponent implements OnInit {
  @ViewChild('content') content: any;
  regFormOne:FormGroup;
  address: FormGroup;
  showForm1 = true;
  showForm2 = false;
  welRegHeader = true;
  subRegHeader = true;
  errorMessage: any;
  isLoading  : boolean= false;

  otpSent = false;
  otpVerified = false;
  isOtpLoading = false;
  verifyingOtp = false;
  otpMessage = '';
  protected readonly faPen = faPen;
  protected readonly faCheckCircle = faCheckCircle;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly registerService: RegisterService,
    private readonly modalService: NgbModal,
    private readonly authService: AuthService
  ){
    this.regFormOne =this.formBuilder.group({
      companyInformation:this.formBuilder.group({
        gstin: [''],
        pan: [''],
      }),
      name: ['', Validators.required],
      userName: ['', Validators.required],
      userPhoneNumber: ['',  [
        Validators.required,
        Validators.pattern(RegExpPatterns.MobilePattern),
      ],
    ],
    phoneNumber:['',  [
        Validators.pattern(RegExpPatterns.MobilePattern),
      ],
    ] ,
      checkbox:['',Validators.requiredTrue],
      email: ['',[Validators.pattern(RegExpPatterns.EmailPattern)]],
      ownerName:[''],
      enrollmentType:'Company',
      address: this.formBuilder.group({
        line1: ['', Validators.required],
        line2: [''],
        city: [''],
        state: [''],
        country: [''],
        pincode: ['']
      }),
      otp: ['', [Validators.pattern('^[0-9]{6}$')]]
    })
    this.address = this.regFormOne.get('address') as FormGroup;
  }

  ngOnInit(): void{
    this.showForm1 = true;
    if( this.showForm2){
      this.showForm1 = false;
      this.welRegHeader = false;
      this.subRegHeader = false;
    }
  }

  get isVerifyEnabled(): boolean {
    const nameValid = this.regFormOne.get('name')?.valid;
    const userNameValid = this.regFormOne.get('userName')?.valid;
    const userPhoneValid = this.regFormOne.get('userPhoneNumber')?.valid;
    const addressLine1Valid = this.regFormOne.get('address.line1')?.valid;
    const companyEmailValid = this.regFormOne.get('email')?.valid;
    const companyPhoneValid = this.regFormOne.get('phoneNumber')?.valid;
    
    return !!(nameValid && userNameValid && userPhoneValid && addressLine1Valid && companyEmailValid && companyPhoneValid);
  }

  sendOtp(): void {
    const userPhone = this.regFormOne.get('userPhoneNumber')?.value;
    if (!userPhone) return;
    this.isOtpLoading = true;
    this.errorMessage = '';
    this.authService.getRegisterOtp({ phoneNumber: userPhone.toString() }).subscribe({
      next: (res: any) => {
        this.isOtpLoading = false;
        this.otpSent = true;
        this.otpMessage = 'OTP sent successfully.';
      },
      error: (err) => {
        this.isOtpLoading = false;
        this.errorMessage = err?.error?.error?.message || 'Failed to send OTP.';
      }
    });
  }

  verifyOtp(otpVal: string): void {
    const userPhone = this.regFormOne.get('userPhoneNumber')?.value;
    if (!userPhone || !otpVal) return;
    this.verifyingOtp = true;
    this.errorMessage = '';
    this.authService.submitRegistrationOtp({
      phoneNumber: userPhone.toString(),
      otp: otpVal.toString()
    }).subscribe({
      next: (res: any) => {
        this.verifyingOtp = false;
        this.otpVerified = true;
        this.otpSent = false;
        this.otpMessage = 'Phone verified successfully.';
      },
      error: (err) => {
        this.verifyingOtp = false;
        this.errorMessage = err?.error?.error?.message || 'Invalid OTP. Please try again.';
      }
    });
  }

  saveRegisterData(){
    this.isLoading = true; 
    let payload = { ...this.regFormOne.value }
    delete payload.otp
    this.registerService.saveRegisterDetails(payload).subscribe({
      next: (res:any) => {
      this.isLoading = false;
      this.showForm1 = false;
      this.showForm2 = true;
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.isLoading = false;
    }
    })
  }

  openPopup() {
    this.modalService.open(this.content);
  }

  onInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.regFormOne.controls['userPhoneNumber'].setValue(inputElement.value);
    }
  }

  input(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 10) {
      inputElement.value = inputElement.value.slice(0, 10);
      this.regFormOne.controls['phoneNumber'].setValue(inputElement.value);
    }
  }

  onOtpInput(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    if (inputElement.value.length > 6) {
      inputElement.value = inputElement.value.slice(0, 6);
      this.regFormOne.controls['otp'].setValue(inputElement.value);
    }
  }
}
